<div [formGroup]="form" class="flex flex-column gap-2">
  <label [attr.for]="item.key" class="font-semibold"
    >{{ item.label || '' | translate }}
    <span class="asterisk" *ngIf="item.required">*</span>
  </label>
  <div class="flex gap-2" [ngClass]="{ 'flex-column': direction === 'column' }">
    <div
      class="field-checkbox"
      *ngFor="let option of item.options || []; let i = index"
    >
      <p-checkbox
        ngClass="{{ isInValid ? 'ng-invalid ng-dirty' : '' }}"
        [formControl]="$any(form.controls[item.key])"
        [name]="item.key"
        [value]="option.value"
        [disabled]="option.disabled"
        inputId="binary"
      >
      </p-checkbox>
      <label [for]="item.key">{{ option.label }}</label>
    </div>
  </div>

  <small
    class="p-error block font-italic"
    *ngIf="isInValid && hasError('required')"
  >
    {{
      item.errorMessage?.required?.message || ''
        | translate : item.errorMessage?.required?.params
    }}
  </small>
</div>
